import { TYPE_COLOR } from '../tokens';

export default function Post({ post, tokens, compact = false }) {
  const typeColor = TYPE_COLOR[post.type] || tokens.textLow;
  return (
    <article style={{
      padding: compact ? '18px 0' : '28px 0',
      borderBottom: `1px solid ${tokens.edge}`,
      animation: `gl-fade-up 500ms ${tokens.ease} both`,
    }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 10 }}>
        <span style={{
          fontFamily: tokens.fontDisplay,
          fontSize: tokens.displayMd - 4,
          fontStyle: 'italic',
          color: tokens.textHi,
          letterSpacing: tokens.displayTracking,
        }}>{post.alias}</span>
        <span style={{
          fontFamily: tokens.fontMono, fontSize: 10, letterSpacing: '0.14em',
          textTransform: 'uppercase', color: tokens.textLow,
        }}>&middot; {post.dept}</span>
        <span style={{ flex: 1 }} />
        <span style={{
          fontFamily: tokens.fontMono, fontSize: 10, letterSpacing: '0.14em',
          textTransform: 'uppercase', color: typeColor, opacity: 1,
        }}>{post.type}</span>
      </div>
      <p style={{
        fontFamily: tokens.fontBody, fontSize: compact ? 14 : tokens.bodyLg,
        lineHeight: 1.65, color: tokens.textHi, margin: 0,
        textWrap: 'pretty', whiteSpace: 'pre-wrap',
      }}>{post.body}</p>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 20, marginTop: 16,
        fontFamily: tokens.fontMono, fontSize: 11, letterSpacing: '0.06em',
        color: tokens.textLow,
      }}>
        <span>{post.timeAgo}</span>
      </div>
    </article>
  );
}
